import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { DispatchType } from "../../shared/utilities";
import { fetchTestProcessData } from "../actions/TestProcessActions";
import { State } from "../model/State";

let pollingTimeOutMs = 3000;
let maxWaitTimeMsForProcessStart = 45000; // 45 seconds hould be enough for any agent to start the process and for the logService to get the Process started message saved

export function setPollingTimeOutValueMs(pollingInterval: number, maxPollingTime: number) {
    pollingTimeOutMs = pollingInterval;
    maxWaitTimeMsForProcessStart = maxPollingTime;
}

export class PollingComponent extends React.Component<React.PropsWithChildren<PollingProps>, PollingOwnState> {
    private timeout: NodeJS.Timeout | null;
    public constructor(props: PollingProps) {
        super(props);
        this.state = { 
            currentWaitTimeMs: 0,
            timeout: null,
            shouldTestProcessBeRunning: false,
            onComplete: null,
            onFailureToStartProcess: null,
            testProcessExecutionId: ""
        };
        if (this.props.shouldTestProcessBeRunning) {
            this.props.onStartPoll();
        }
    }

    static startPoll(props: PollingProps) {
        return setTimeout(() => props.onStartPoll(), pollingTimeOutMs);
    }

    public componentDidUpdate(prevProps: PollingProps) {
        if (!_.isEqual(prevProps, this.props)) {
            clearTimeout(this.timeout as NodeJS.Timeout);
            if (this.props.shouldTestProcessBeRunning && !this.props.isFetchingResults) {
                const curentWaitTime = this.state.currentWaitTimeMs + pollingTimeOutMs;
                if (this.props.isProcessStarted === false && maxWaitTimeMsForProcessStart < curentWaitTime) {
                    this.props.onFailureToStartProcess();
                } else {
                    this.setState({ currentWaitTimeMs: curentWaitTime });
                    this.startPoll();
                }
            } else if (!this.props.shouldTestProcessBeRunning && prevProps.shouldTestProcessBeRunning) {
                this.setState({ currentWaitTimeMs: 0 });
                this.props.onComplete();
            }
        }
    }

    public componentWillUnmount() {
        clearTimeout(this.timeout as NodeJS.Timeout);
    }

    public render() {
        return <div>{this.props.children}</div>;
    }

    private startPoll() {
        this.timeout = setTimeout(() => this.props.onStartPoll(), pollingTimeOutMs);
    }
}

interface PollingOwnState {
    currentWaitTimeMs: number;
    timeout: NodeJS.Timeout | null;
    shouldTestProcessBeRunning: boolean;
    testProcessExecutionId: string;
    onComplete: (() => void) | null;
    onFailureToStartProcess: (() => void) | null;
}

interface PollingOwnProps {
    testProcessExecutionId: string | null;
    environmentName: string;
    onComplete: () => void;
    onFailureToStartProcess: () => void;
}

interface PollingStateProps {
    isFetchingResults: boolean | undefined;
    shouldTestProcessBeRunning: boolean;
    isProcessStarted: boolean;
}

interface PollingDispatchProps {
    onStartPoll: () => void;
}

export type PollingProps = PollingOwnProps & PollingStateProps & PollingDispatchProps;
const mapStateToProps = (state: State, ownProps: PollingProps): PollingStateProps => {
    return {
        isFetchingResults: state.uiState.isTestProcessFetching,
        shouldTestProcessBeRunning: ownProps.testProcessExecutionId != null,
        isProcessStarted: ownProps.testProcessExecutionId != null && state.testProcess.executions && state.testProcess.executions[0].result != null
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: PollingOwnProps): PollingDispatchProps => {
    return {
        onStartPoll: () => dispatch(fetchTestProcessData(ownProps.testProcessExecutionId, ownProps.environmentName)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PollingComponent) as React.ComponentType<React.PropsWithChildren<PollingOwnProps>>;
